<template>
  <a :href="item.link" class="InitiativeCard">
    <div class="image-wrapper">
      <img :src="item.image" :alt="item.name">
    </div>
    <div class="text-wrapper">
      <span class="text primary font-size-16" v-html="item.text"></span>
      <span class="cta font-weight-600 font-size-16" v-html="`${item.link_text} >`"></span>
    </div>
  </a>
</template>
<script>
  export default {
  	name: "InitiativeCard",
    props: {
    	item: {
        type: Object,
        default: ()=>{
          return {}
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  @import "~@root/less/func/variables";
  @import "~@root/less/func/elements";
  @import "~@root/less/func/common";

  .InitiativeCard {
    &:link, &:visited, &:hover, &:active{
      text-decoration: none;
    }
    .image-wrapper{
      padding-top: 56.25%;
      height: 0;
      position: relative;
      overflow: hidden;
      img{
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;
      }
      span{
        position: absolute;
        bottom: 0;
        padding: 15px 32px;
      }
    }

    .text-wrapper{
      margin-top: 20px;
      span{
        display: block;
      }
    }

    .cta{
      color: @blue;
    }
  }
</style>